import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = { // 要设置的全局访问的state对象
  // 要设置的初始属性值
  themeColor: '#459f75'
}
const getters = { // 实时监听state值的变化(最新状态)
  themeColor: state => state.themeColor
}
const mutations = {
  // 更新主题颜色
  setThemeColor (state, val) {
    state.themeColor = val
  }
}

const actions = {
  changeSetting ({ commit }, data) {
    commit('setThemeColor', data)
  }
}

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js